import React, { useState, useEffect, useRef } from "react";
import "./Faqs.scss";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import AddIcon from "@mui/icons-material/Add";
import CloseIcon from "@mui/icons-material/Close";
import { Box, Grid2, useTheme} from "@mui/material";
import RemoveIcon from "@mui/icons-material/Remove";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { reset } from "../../../../layouts/WebLayout/SkipToMainContent/SkipToMainContentSlice";

interface FaqsProps {
  bgColor?: string;
  borderStyle?: string;
}

interface FAQ {
  id?: number;
  question?: string;
  answer?: string;
}

interface FAQCategory {
  id?: number;
  name?: string;
  sort?: number;
  faqs?: FAQ[];
}

const Faqs: React.FC<FaqsProps> = ({ bgColor = "#F1F7FF", borderStyle }) => {

  const [expanded, setExpanded] = useState<string | false>(false);
  const [childExpanded, setChildExpanded] = useState<string | false>(false);
  const [faqsData, setfaqsData] = useState<FAQCategory[]>([]);
  const theme = useTheme();
  const dynamicBgColor = theme.palette.mode === "light" ? bgColor : theme.palette.background.default;
  const faqRef=useRef<HTMLElement | null>();

  useEffect(()=>{
    const getFAQs = async () =>{
      try {
      const FAQResponse = await axios.get(`${process.env.API_URL}/items/master_generals?fields=id,name,sort,faqs.id,faqs.question,faqs.answer,faqs.sort,faqs.status&filter[type]=faq_category&filter[status]=published&sort[]=sort&deep[faqs][_sort]=sort`)
      setfaqsData(FAQResponse?.data?.data)
      // console.log(FAQResponse?.data?.data,"faqs test"); 
      } catch(err){
        // Failed to fetch FAQs
      }
    }
    getFAQs();
  },[]);

  const skipClicked=useSelector((state:any)=>
    {
       return state?.skip?.SkipButtonClicked
   });
const dispatch=useDispatch();

 const handleScroll = () => {
        if (faqRef.current) {
          faqRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
          dispatch(reset());
        }
      }
      useEffect(()=>{
        if(skipClicked){
        handleScroll() 
        } 
      },[skipClicked])


  
  const handleChange =
  (panel: string) => (event: React.SyntheticEvent, isExpanded: boolean) => {
    setExpanded(isExpanded ? panel : false);
  };

  const handleChildChange =
  (panel: string) => (event: React.SyntheticEvent, isExpanded: boolean) => {
    setChildExpanded(isExpanded ? panel : false);
  };

  return (
    <Box
      sx={{
        padding: { xs: "2rem 0", md: "4rem 0" },
        backgroundColor: dynamicBgColor,
      }}
    >
      <Grid2
        container
        sx={{
          justifyContent: "center",
        }}
      >
        <Grid2 size={{ xs: 12, md: 8 }} className="faq-wrap" ref={faqRef as any}>
          <Typography
            variant="h2"
            sx={{
              textAlign: "center",
              // fontSize: { xs: "1.125rem", md: "2.813rem" },
              fontSize: {
                xs: `calc(1.125rem * var(--dynamic-font-size, 1))`,
                md: `calc(2.813rem * var(--dynamic-font-size, 1))`,
              },
              fontWeight: "600",
              lineHeight: { xs: "35px", md: "65px" },
              // color: "#000000",
              margin: { xs: "30px 0", md: "60px 0" },
            }}
          >
            Frequently Asked Questions
          </Typography>

          {faqsData.map(({ id, name, faqs }) => (
            <Accordion
              expanded={expanded === String(id)}
              onChange={handleChange(String(id))}
              key={id}
              sx={{
                border: borderStyle,
                borderLeft: theme.palette.mode == "light" ? "6px solid #449CFD" : "6px solid #485765" ,
                fontSize: `calc(16px * var(--dynamic-font-size, 1))`, 
              }}
              className="parent-accordion"
            >
              <AccordionSummary
                expandIcon={expanded === String(id) ? <CloseIcon /> : <AddIcon />}
                aria-controls={`${id}-content`}
                id={`${id}-header`}
                sx={{
                  fontSize: `calc(16px * var(--dynamic-font-size, 1))`, // Dynamic font size for AccordionSummary
                }}
              >
                <Typography>{name}</Typography>
              </AccordionSummary>
              <AccordionDetails
               sx={{
                fontSize: `calc(16px * var(--dynamic-font-size, 1))`, // Dynamic font size for AccordionDetails
              }}
              >
                {/* <Typography>{answer}</Typography> */}
                {Array.isArray(faqs) && faqs.length > 0 && (
                  <Box sx={{ marginTop: 2 }}>
                    {faqs?.map(({ id: subId, question: subQuestion, answer: subAnswer }) => (
                      <Accordion
                        expanded={childExpanded === String(subId)}
                        onChange={handleChildChange(String(subId))}
                        key={subId}
                        sx={{
                          fontSize: `calc(14px * var(--dynamic-font-size, 1))`, 
                        }}
                        className="child-accordion"
                      >
                        <AccordionSummary
                          expandIcon={childExpanded  === String(subId) ? <RemoveIcon /> : <AddIcon />}
                          aria-controls={`${subId}-content`}
                          id={`${subId}-header`}
                          sx={{
                            fontSize: `calc(14px * var(--dynamic-font-size, 1))`,
                          }}
                        >
                          <Typography>{subQuestion}</Typography>
                        </AccordionSummary>
                        <AccordionDetails
                          sx={{
                            fontSize: `calc(14px * var(--dynamic-font-size, 1))`,
                          }}
                        >
                          <Typography>{subAnswer}</Typography>
                        </AccordionDetails>
                      </Accordion>
                    ))}
                  </Box>
                )}
              </AccordionDetails>
            </Accordion>
          ))}
        </Grid2>
      </Grid2>
    </Box>
  );
};

export default Faqs;
